import axios from "axios";
import { Action, Thunk, thunk, action } from "easy-peasy";
import { CMS_ITEMS, CMS_PARAMS } from "utils/cmsConstants";

export interface CmsContentModel {
  airlines: any[];
  clearAirlines: Action<CmsContentModel>;
  setAirlines: Action<CmsContentModel, any>;
  fetchAirline: Thunk<CmsContentModel, any>;
}

const CmsContentStore: CmsContentModel = {
  airlines: [],

  setAirlines: action((state, airline) => {
    state.airlines = airline;
  }),

  clearAirlines: action((state) => {
    state.airlines = [];
  }),

  fetchAirline: thunk(async (actions) => {
    actions.clearAirlines();
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_URL}/items/${CMS_ITEMS.AIRLINE}`,
        {
          params: CMS_PARAMS.airline,
          headers: {
            Authorization: `bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        },
      );
      console.log("response", response);
      actions.setAirlines(response.data.data || []);
    } catch (e) {
      console.log(e);
    }
  }),
};

export default CmsContentStore;
